import { render, staticRenderFns } from "./P01.vue?vue&type=template&id=5ae04128&scoped=true"
import script from "./P01.vue?vue&type=script&lang=js"
export * from "./P01.vue?vue&type=script&lang=js"
import style0 from "./P01.vue?vue&type=style&index=0&id=5ae04128&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae04128",
  null
  
)

export default component.exports